import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { alignVariants } from "../../utils/vanilla/alignVariants";

export const messageStyle = recipe({
  base: {},
  variants: {
    alignSelf: {
      ...alignVariants("alignSelf"),
    },
  },
});

export const messageBodyStyle = style({
  flexGrow: 1,
  paddingTop: rem(6),
});

export const contentStyle = style({
  alignItems: "flex-start",
});
